import { create } from "zustand";

/**
 * The add-to-lookbook the visibility dialog is currently configuring.
 *
 * This exists as a store rather than component state because the trigger lives
 * inside a Radix dropdown, which unmounts its whole subtree when the menu
 * closes. A dialog rendered in there would unmount mid-interaction. So the menu
 * records the intent here, and a host mounted beside the pipeline renders the
 * dialog.
 */
export interface PendingLookbookAdd {
  mode: "existing" | "create";
  /** Absent in create mode — the lookbook doesn't exist yet. */
  lookbookId?: string;
  lookbookName: string;
  companyIds: string[];
  /** Clears the pipeline's bulk selection once the add goes through. */
  onDone?: () => void;
}

interface LookbookVisibilityState {
  pending: PendingLookbookAdd | null;
  open: (pending: PendingLookbookAdd) => void;
  close: () => void;
}

export const useLookbookVisibilityStore = create<LookbookVisibilityState>(
  (set) => ({
    pending: null,
    open: (pending) => set({ pending }),
    close: () => set({ pending: null }),
  })
);
